/**
 * Short-height breakpoint. Below this viewport height the sidebar tightens
 * vertical paddings, the header reflows to a single row, and the New button
 * switches to icon-only.
 *
 * Consumed by:
 *  - JS: components/GlobalButton/GlobalButton.tsx (via useMediaQuery)
 *  - CSS: MainSidebar.module.css, components/SidebarFooter/SidebarFooter.module.css
 *    (mirrored as `@media (max-height: 600px)` — keep in sync with SHORT_HEIGHT_PX)
 */
export const SHORT_HEIGHT_PX = 600
export const SHORT_HEIGHT_MEDIA_QUERY = `(max-height: ${SHORT_HEIGHT_PX}px)`
